export const defaultAction = type => () => ({ type })

export const applyModelUpdate = defaultAction
export const cancelModelUpdate = defaultAction
export const updateModel = type => (name, value) => ({ type, name, value })
export const updateImage = type => file => ({ type, file })
export const applyFilterCriteria = defaultAction
export const clearFilterCriteria = defaultAction
export const updateFilterCriteria = type => (name, value) => ({
    type,
    name,
    value
})
export const setFilter = type => isFilterActive => ({ type, isFilterActive })
export const setEditMode = type => isEditMode => ({ type, isEditMode })
export const itemResponse = type => parameters => ({ type, ...parameters })
export const itemRequest = type => (
    id,
    isInvalidating,
    callbackActionCreator
) => ({
    type,
    id,
    isInvalidating,
    callbackActionCreator
})
export const listResponse = type => data => ({ type, data })
export const listPageRequest = (
    type,
    listResponseCreator
) => pagingRequest => ({
    type,
    ...pagingRequest,
    callbackActionCreator: listResponseCreator
})
export const listSearchRequest = (type, listResponseCreator) => (
    name,
    value
) => ({
    type,
    name,
    value,
    callbackActionCreator: listResponseCreator
})
